import { render, staticRenderFns } from "./ManageBooking.vue?vue&type=template&id=27c5a3dd"
import script from "./ManageBooking.vue?vue&type=script&lang=js"
export * from "./ManageBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports